(function () {
  if (window.customElements.get('up2-cal-embed')) return;

  var EMBED_SRC = 'https://app.cal.com/embed/embed.js';
  var ORIGIN = 'https://cal.com';
  var BRAND = '#2A7FFF';
  var MODAL_NS = 'up2calmodal';
  var LIGHT_UI = {
    theme: 'light',
    hideEventTypeDetails: false,
    cssVarsPerTheme: {
      light: { 'cal-brand': BRAND },
      dark: { 'cal-brand': BRAND },
    },
  };

  function bookingLink(el) {
    if (!el || !el.getAttribute) return '';
    return (el.getAttribute('data-up2-cal-link') || el.getAttribute('data-cal-link') || '').trim();
  }

  function ensureSnippet() {
    if (typeof window.Cal === 'function') return;
    (function (C, A, L) {
      var p = function (a, ar) {
        a.q.push(ar);
      };
      var d = C.document;
      C.Cal =
        C.Cal ||
        function () {
          var cal = C.Cal;
          var ar = arguments;
          if (!cal.loaded) {
            cal.ns = {};
            cal.q = cal.q || [];
            d.head.appendChild(d.createElement('script')).src = A;
            cal.loaded = true;
          }
          if (ar[0] === L) {
            var api = function () {
              p(api, arguments);
            };
            var namespace = ar[1];
            api.q = api.q || [];
            if (typeof namespace === 'string') {
              cal.ns[namespace] = cal.ns[namespace] || api;
              p(cal.ns[namespace], ar);
              p(cal, ['initNamespace', namespace]);
            } else p(cal, ar);
            return;
          }
          p(cal, ar);
        };
    })(window, EMBED_SRC, 'init');
  }

  function namespaceName(id) {
    return 'up2cal' + String(id || 'embed').replace(/[^a-zA-Z0-9]/g, '');
  }

  function apiFor(ns) {
    if (window.Cal.ns && window.Cal.ns[ns]) return window.Cal.ns[ns];
    return window.Cal;
  }

  function layoutForViewport() {
    return window.matchMedia('(min-width: 750px)').matches ? 'month_view' : 'column_view';
  }

  function applyLightUi(api, layout) {
    api('ui', Object.assign({ layout: layout }, LIGHT_UI));
  }

  // Cal.com only renders its compact booker (details | month | slots) from ~768px iframe width.
  // Narrower, the inline calendar stacks into oversized cells and a clipped slot list, so the
  // element shows its booking card instead and the button opens the full-screen Cal modal.
  var INLINE_MIN_WIDTH = 768;

  var Up2CalEmbed = class extends HTMLElement {
    connectedCallback() {
      if (this._watching) return;
      var link = bookingLink(this);
      if (!link) return;
      this._watching = true;
      bindModalClicks();
      this.setAttribute('data-mode', 'card');
      if (this.tryInline()) return;
      if (typeof ResizeObserver !== 'function') return;
      var self = this;
      this._observer = new ResizeObserver(function () {
        if (self.tryInline()) self._observer.disconnect();
      });
      this._observer.observe(this);
    }

    disconnectedCallback() {
      if (this._observer) this._observer.disconnect();
    }

    tryInline() {
      if (this._bound) return true;
      if (this.clientWidth < INLINE_MIN_WIDTH) return false;
      this._bound = true;
      this.setAttribute('data-mode', 'inline');
      var link = bookingLink(this);
      ensureSnippet();
      bindOverlayWatch();
      var ns = namespaceName(this.getAttribute('data-namespace') || this.id || link);
      var layout = 'month_view';
      var locale = (this.getAttribute('data-locale') || document.documentElement.lang || 'de').slice(0, 2);
      window.Cal('init', ns, { origin: ORIGIN });
      var api = apiFor(ns);
      api('inline', {
        elementOrSelector: this,
        calLink: link,
        config: {
          layout: layout,
          theme: 'light',
          locale: locale,
        },
      });
      applyLightUi(api, layout);
      return true;
    }
  };

  function bookingPathFromHref(href) {
    if (!href) return '';
    if (/calendly\.com\/up2promo/i.test(href)) return 'up2stay/15min';
    var match = href.match(/cal\.com\/([^?#]+)/i);
    if (!match) return '';
    return match[1].replace(/^\/+/, '').replace(/\/embed\/?$/, '');
  }

  function isBookingHref(href) {
    return /(?:cal\.com\/up2stay|calendly\.com\/up2promo)/i.test(href || '');
  }

  function openCalBoxes() {
    return document.querySelectorAll('cal-modal-box:not([state="closed"])');
  }

  function ensureModalApi() {
    ensureSnippet();
    bindOverlayWatch();
    if (!window.__up2CalModalReady) {
      window.Cal('init', MODAL_NS, { origin: ORIGIN });
      window.__up2CalModalReady = true;
    }
    var api = apiFor(MODAL_NS);
    applyLightUi(api, layoutForViewport());
    return api;
  }

  function openModal(path, localeHint) {
    var link = (path || '').trim();
    if (!link) return;
    if (openCalBoxes().length) return;
    var layout = layoutForViewport();
    var locale = (localeHint || document.documentElement.lang || 'de').slice(0, 2);
    var api = ensureModalApi();
    api('modal', {
      calLink: link,
      config: {
        layout: layout,
        theme: 'light',
        locale: locale,
        useSlotsViewOnSmallScreen: 'true',
      },
    });
  }

  function restorePageScroll() {
    if (openCalBoxes().length) {
      document.documentElement.style.setProperty('color-scheme', 'light');
      return;
    }
    document.documentElement.style.removeProperty('color-scheme');
    document.body.style.removeProperty('overflow');
    document.documentElement.style.removeProperty('overflow');
  }

  function bindOverlayWatch() {
    if (window.__up2CalOverlayWatch) return;
    window.__up2CalOverlayWatch = true;
    var style = document.createElement('style');
    style.textContent = 'cal-modal-box[state="closed"]{display:none!important;pointer-events:none!important}';
    document.head.appendChild(style);
    var observer = new MutationObserver(restorePageScroll);
    observer.observe(document.documentElement, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['state'],
    });
  }

  function bindModalClicks() {
    if (window.__up2CalModalBound) return;
    window.__up2CalModalBound = true;
    document.addEventListener(
      'click',
      function (event) {
        if (event.button !== 0) return;
        if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        var opener = event.target.closest('[data-up2-cal-open]');
        if (opener) {
          var embed = opener.closest('up2-cal-embed');
          event.preventDefault();
          event.stopPropagation();
          openModal(bookingLink(embed), embed && embed.getAttribute('data-locale'));
          return;
        }
        var host = event.target.closest('up2-cal-trigger');
        if (host) {
          event.preventDefault();
          event.stopPropagation();
          openModal(bookingLink(host), host.getAttribute('data-locale'));
          return;
        }
        var anchor = event.target.closest('a[href]');
        if (!anchor) return;
        var href = anchor.getAttribute('href') || '';
        if (!isBookingHref(href)) return;
        event.preventDefault();
        event.stopPropagation();
        openModal(bookingPathFromHref(href), document.documentElement.lang);
      },
      true,
    );
  }

  var Up2CalTrigger = class extends HTMLElement {
    connectedCallback() {
      bindModalClicks();
    }
  };

  window.customElements.define('up2-cal-embed', Up2CalEmbed);
  window.customElements.define('up2-cal-trigger', Up2CalTrigger);
  bindModalClicks();
})();
